import moment, { Moment } from "moment";

export function AssertIsSameDate(
  time: string | Date | Moment,
  expectTime: string | Date | Moment,
  compareType: compareType = "day"
) {
  return moment(time).isSame(moment(expectTime), compareType);
}

export function AssertIsSameRange(
  range: { from: string | Date | Moment; to: string | Date | Moment },
  expectRange: { from: string | Date | Moment; to: string | Date | Moment },
  compareType: compareType = "day"
) {
  return (
    AssertIsSameDate(range.from, expectRange.from, compareType) &&
    AssertIsSameDate(range.to, expectRange.to, compareType)
  );
}

export function AssertIsBeforeDate(
  time: string | Date | Moment,
  expectTime: string | Date | Moment,
  compareType: compareType = "day"
) {
  return moment(time).isBefore(moment(expectTime), compareType);
}

export function AssertIsBeforeOrEqualDate(
  time: string | Date | Moment,
  expectTime: string | Date | Moment,
  compareType: compareType = "day"
) {
  return (
    AssertIsBeforeDate(time, expectTime, compareType) ||
    AssertIsSameDate(time, expectTime, compareType)
  );
}

export function AssertIsAfterOrEqualDate(
  time: string | Date | Moment,
  expectTime: string | Date | Moment,
  compareType: compareType = "day"
) {
  return (
    AssertIsAfterDate(time, expectTime, compareType) ||
    AssertIsSameDate(time, expectTime, compareType)
  );
}

export function AssertIsAfterDate(
  time: string | Date | Moment,
  expectTime: string | Date | Moment,
  compareType: compareType = "day"
) {
  return moment(time).isAfter(moment(expectTime), compareType);
}

export function AssertIsBetweenDate(
  time: string | Date | Moment,
  earlierExpectTime: string | Date | Moment,
  laterExpectTime: string | Date | Moment,
  compareType: compareType = "day"
) {
  return (
    AssertIsAfterOrEqualDate(time, earlierExpectTime, compareType) &&
    AssertIsBeforeOrEqualDate(time, laterExpectTime, compareType)
  );
}

type compareType =
  | "second"
  | "minute"
  | "hour"
  | "day"
  | "week"
  | "month"
  | "year";
